import { Component, OnInit } from '@angular/core';
import { DadoTransacional } from '../../comum/modelos/dado-transacional';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { ConstrucaoVariaveisService } from '../construcao-variaveis.service';
import { PontoFisicoService } from '../../ponto-fisico/ponto-fisico.service';
import { ComumService } from '../../comum/comum.service';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';


@Component({
  selector: 'app-cadastro-dado-transacional',
  templateUrl: './cadastro-dado-transacional.component.html',
  styleUrls: ['./cadastro-dado-transacional.component.css']
})
export class CadastroDadoTransacionalComponent implements OnInit {

  dadoTransacional: DadoTransacional;
  pontosFisicos: PontoFisico[];
  dateFormat = 'dd/mm/yy';

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  public loading = false;
  public statusCode: number;
  pt: any;

  constructor(private _construcaoVariaveisService: ConstrucaoVariaveisService,
    private _pontoFisicoService: PontoFisicoService,
    private _comumService: ComumService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.dadoTransacional = new DadoTransacional();
    this.pontosFisicos = new Array<PontoFisico>();
  }

  ngOnInit() {
    this.pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'ter\xE7a', 'quarta', 'quinta', 'sexta', 's\xE1bado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\xE1b'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: ['janeiro', 'fevereiro', 'mar\xE7o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro',
        'outubro', 'novembro', 'dezembro'],
      monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      today: 'Hoje',
      clear: 'Apagar'
    };
    const id = this._activatedRoute.snapshot.params['id'];
    const idCliente = parseInt(this._cookieService.get('idCliente'));
    this.loading = true;
    const self = this;

    if (id !== undefined) {
      forkJoin(this._construcaoVariaveisService.obterDadoTransacionalPorIdHttp(id),
        this._pontoFisicoService.obterPontosFisicoClienteHttp(idCliente))
        .subscribe(([dadoTransacional, pontosFisicos]) => {
          self.dadoTransacional = dadoTransacional;
          self.dadoTransacional.dataInicio = new Date(dadoTransacional.dataInicio);
          self.dadoTransacional.dataFim = new Date(dadoTransacional.dataFim);
          self.pontosFisicos = pontosFisicos;
          self.MODO = self.ATUALIZAR;
          self.loading = false;
        });
    } else {
      this.MODO = this.CADASTRAR;
      this.dadoTransacional.idCliente = idCliente;
      this._pontoFisicoService.obterPontosFisicoClienteHttp(idCliente)
        .subscribe((pontosFisicos: PontoFisico[]) => {
          self.pontosFisicos = pontosFisicos;
          self.loading = false;
        });
    }
  }

  onSubmit(): void {

    const self = this;

    if (this.MODO === this.CADASTRAR) {
      this._construcaoVariaveisService.cadastrarDadoTransacionalHttp(this.dadoTransacional)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['variaveis']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    } else {
      this._construcaoVariaveisService.atualizarDadoTransacionalHttp(this.dadoTransacional)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          self.router.navigate(['variaveis']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
  }

  parseDate(dateString: string): Date {
    if (dateString) {
      return new Date(dateString);
    } else {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/construcao-variaveis/cadastro-dado-transacional/cadastro-dado-transacional.component.ts